import React from 'react';
import { PartyPopper, Heart, Briefcase, GraduationCap, Users, Cake } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { targetGroups } from '../data/mock';

const Events = () => {
  const events = [
    {
      icon: Cake,
      title: 'Narozeninové oslavy',
      color: 'from-pink-500 to-rose-500'
    },
    {
      icon: Heart,
      title: 'Svatby',
      color: 'from-rose-500 to-red-500'
    },
    {
      icon: PartyPopper,
      title: 'Srazy',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: Briefcase,
      title: 'Firemní večírky',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: GraduationCap,
      title: 'Školní výlety',
      color: 'from-emerald-500 to-teal-500'
    },
    {
      icon: Users,
      title: 'Soustředění',
      color: 'from-amber-500 to-orange-500'
    }
  ];

  return (
    <>
      {/* Main Events Section */}
      <section className="py-16 bg-gradient-to-br from-emerald-600 via-emerald-700 to-teal-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full filter blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src="https://i.ibb.co/p6mT366r/ee36b6e1-6d6a-4b45-a3bd-feb7987d5c46.jpg"
                  alt="Akce v kempu - svatby, oslavy, večírky"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-emerald-400 rounded-3xl -z-10"></div>
            </div>

            <div className="text-white">
              <div className="mb-8">
                <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
                  <PartyPopper className="w-5 h-5" />
                  <span className="text-sm font-semibold">Pořádáme akce</span>
                </div>
                <h2 className="text-4xl md:text-5xl font-bold mb-4">
                  Ideální místo pro vaše akce
                </h2>
                <p className="text-emerald-100 text-lg leading-relaxed">
                  Náš kemp je perfektním místem pro organizaci nejrůznějších akcí. 
                  Nabízíme kompletní zázemí, catering a přátelskou atmosféru.
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {events.map((event, index) => (
                  <Card
                    key={index}
                    className="bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 cursor-pointer"
                  >
                    <CardContent className="p-4 text-center">
                      <div className={`w-12 h-12 bg-gradient-to-br ${event.color} rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg`}>
                        <event.icon className="w-6 h-6 text-white" />
                      </div>
                      <p className="text-white font-semibold text-sm">
                        {event.title}
                      </p>
                    </CardContent>
                  </Card>
                ))}
              </div>

              <div className="mt-8 flex items-center space-x-4">
                <a href="tel:+420721022279">
                  <button className="bg-white text-emerald-700 px-8 py-4 rounded-xl font-bold hover:bg-emerald-50 transition-all duration-300 hover:scale-105 shadow-xl">
                    Rezervovat akci
                  </button>
                </a>
                <p className="text-emerald-100 text-sm">
                  Zavolejte nám a domluvíme vše potřebné
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Target Groups Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Ideální pro skupiny a akce
              </h2>
              <p className="text-lg text-gray-600">
                Kemp Josef je perfektním místem nejen pro rodinné dovolené, ale také pro různé skupinové akce a události
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {targetGroups.map((group, index) => (
                <Card key={index} className="bg-emerald-50 border-emerald-200 hover:shadow-lg transition-shadow">
                  <CardContent className="p-4">
                    <p className="text-sm font-medium text-gray-900 flex items-center">
                      <span className="w-2 h-2 bg-emerald-600 rounded-full mr-3"></span>
                      {group}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>

            <Card className="bg-gradient-to-br from-emerald-600 to-emerald-700 border-0">
              <CardContent className="p-8 text-white text-center">
                <p className="text-xl font-semibold mb-2">
                  Pódium pro hudební akce
                </p>
                <p className="text-emerald-100">
                  K dispozici je pódium pro hudební produkce a živou zábavu
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </>
  );
};

export default Events;